import { resolveThermalReceiptConfig } from './thermalReceiptConfig';
import { mapSaleToThermalReceiptViewModel } from './thermalReceiptMapper';
import { buildThermalReceiptLines } from './thermalReceiptBuilder';
import { renderThermalReceiptHtml } from './thermalReceiptHtmlRenderer';
import {
  renderThermalReceiptEscPos,
  renderThermalReceiptEscPosBase64
} from './thermalReceiptEscPosRenderer';
import { getReceiptLabel, getReceiptPrintOptions } from '../../utils/receiptLabels';
import {
  getActiveCurrencyLabel,
  readActiveCurrencyType
} from '../../utils/posCurrencyUtils';

export {
  resolveThermalReceiptConfig,
  resolveThermalPaperWidthKey,
  resolveThermalPaperProfile,
  computeThermalFontSizePx,
  thermalMediaWidthMm,
  THERMAL_PAPER_PROFILES,
  THERMAL_RECEIPT_PAPER_80,
  THERMAL_RECEIPT_PAPER_58,
  DEFAULT_THERMAL_PAPER,
  DEFAULT_THERMAL_RECEIPT_CONFIG,
  THERMAL_RECEIPT_PRINT_MARGINS
} from './thermalReceiptConfig';
export { mapSaleToThermalReceiptViewModel } from './thermalReceiptMapper';
export * from './thermalReceiptFormatter';
export { buildThermalReceiptLayoutData } from './thermalReceiptHtmlLayout';
export { renderThermalReceiptHtml } from './thermalReceiptHtmlRenderer';
export { renderThermalReceiptEscPos, renderThermalReceiptEscPosBase64 } from './thermalReceiptEscPosRenderer';

export function getThermalReceiptBuildOptions(receiptType = 'client', language = 'fr', extra = {}) {
  const forMerchant = receiptType === 'merchant';
  const base = getReceiptPrintOptions(language, receiptType);
  const currencyCode = extra.currencyCode || readActiveCurrencyType();
  const currencyLabel =
    extra.currencyLabel || getActiveCurrencyLabel(language, { form: 'short' });
  return {
    ...base,
    merchantCopy: forMerchant,
    useCustomerReceiptNumber: !forMerchant,
    showLocation: forMerchant,
    showCashier: true,
    showCustomer: !forMerchant,
    showNif: forMerchant,
    compactLayout: !forMerchant,
    footerMessage: extra.footerMessage || getReceiptLabel('footerDefault', language),
    title: forMerchant
      ? getReceiptLabel('receiptTitleMerchant', language)
      : getReceiptLabel('receiptTitleClient', language),
    ...extra,
    paperWidth: extra.paperWidth || '80mm',
    currencyCode,
    currencyLabel
  };
}

export function buildThermalReceiptDocument(receiptData, options = {}) {
  const config = resolveThermalReceiptConfig(options);
  const viewModel = mapSaleToThermalReceiptViewModel(receiptData, config);
  const lines = buildThermalReceiptLines(viewModel, config);

  return {
    config,
    viewModel,
    lines,
    text: lines.join('\n')
  };
}

export function buildThermalReceiptHtml(receiptData, options = {}) {
  const documentModel = buildThermalReceiptDocument(receiptData, options);
  return renderThermalReceiptHtml(documentModel, options);
}

export function buildThermalReceiptEscPos(receiptData, options = {}) {
  const documentModel = buildThermalReceiptDocument(receiptData, options);
  return renderThermalReceiptEscPos(documentModel, options);
}

export function buildThermalReceiptEscPosBase64(receiptData, options = {}) {
  const documentModel = buildThermalReceiptDocument(receiptData, options);
  return renderThermalReceiptEscPosBase64(documentModel, options);
}

const thermalReceiptService = {
  buildThermalReceiptDocument,
  buildThermalReceiptHtml,
  buildThermalReceiptEscPos,
  buildThermalReceiptEscPosBase64
};

export default thermalReceiptService;
